import { render, staticRenderFns } from "./JobSummary.vue?vue&type=template&id=ed242924&scoped=true&"
import script from "./JobSummary.vue?vue&type=script&lang=js&"
export * from "./JobSummary.vue?vue&type=script&lang=js&"
import style0 from "./JobSummary.vue?vue&type=style&index=0&lang=css&"
import style1 from "./JobSummary.vue?vue&type=style&index=1&id=ed242924&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed242924",
  null
  
)

export default component.exports